import { render, staticRenderFns } from "./view-message.vue?vue&type=template&id=404b78fd&scoped=true"
import script from "./view-message.vue?vue&type=script&lang=js"
export * from "./view-message.vue?vue&type=script&lang=js"
import style0 from "./view-message.vue?vue&type=style&index=0&id=404b78fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b78fd",
  null
  
)

export default component.exports